import { Component, OnInit } from '@angular/core';
import { ToursService } from 'src/app/_services/tours.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tour-excursion',
  templateUrl: './tour-excursion.component.html',
  styleUrls: ['./tour-excursion.component.css']
})
export class TourExcursionComponent implements OnInit {
  tourId;
  tourDetail;
  imagenes: any[]=[];
  excursions: any[]=[];
  constructor(private tourService: ToursService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private datePipe: DatePipe,
    config: NgbCarouselConfig) {
      const id: string = this.activeRoute.snapshot.paramMap.get('tourid');
      console.log(id);
      if (Number(id) > 0) {
        this.tourId = Number(id);
      }
      config.showNavigationArrows = false;
      config.showNavigationIndicators = true;
      config.interval = 10000;
      config.animation = true;
     }

  ngOnInit(): void {
    this.loadImagen(this.tourId,0);
    this.loadTourDetail(this.tourId);
  }
  loadImagen(idtour,imagenType){
    this.tourService.getImageByType(idtour,imagenType).subscribe(img=>{
      console.log(img);
      this.imagenes = img;
    });
  }
  loadTourDetail(idtour){
    this.tourService.getTourDetail(idtour).subscribe(tour=>{
      this.tourDetail = tour;
      console.log(this.tourDetail);
      this.loadExcursion(this.tourDetail.id);
    });
  }
  loadExcursion(idtour){
    this.tourService.getExcursionByTour(idtour).subscribe(exc=>{
      console.log(exc);
      this.excursions = exc;
    });
  }

}
